/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import Query from "../../../Basis/Queries/Query";

export interface AnzahlTage {
    anzahlTage: number;
}

export default class LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss extends Query<AnzahlTage, void> {
    public static readonly queryName = "Mandanten_LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss";

    private static readonly query = gql`
        query ${LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss.queryName} {
            ${LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss.queryName} {
                anzahlTage
            }
        }
    `;

    constructor(onCompleted: (data: AnzahlTage) => void) {
        super(LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss.query, onCompleted);
    }

    public get name(): string {
        return LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss.queryName;
    }
}
